import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { FormikProps } from 'formik'
import { IArbitrationFormValues, IArbitrationMetadata } from 'types/arbitrationTypes'
import { FormFieldInput } from '../FormFieldInput'
import { FormFieldLabel } from '../FormFieldLabel'
import { StyledFormSection, StyledReadOnlyGrid } from '../ArbitrationForm.styled'

interface IProps {
  metadata: IArbitrationMetadata | null
  formik: FormikProps<IArbitrationFormValues>
  isAddAttachmentsMode: boolean
  selectedContactMethodDescription: string
}

export const ContactInfoSection: React.FC<IProps> = ({
  metadata,
  formik,
  isAddAttachmentsMode,
  selectedContactMethodDescription
}) => {
  return (
    <StyledFormSection>
      <h6>Contact Information</h6>
      {isAddAttachmentsMode ? (
        <StyledReadOnlyGrid>
          <FormFieldLabel label="Name" value={formik.values.contactName || 'N/A'} />
          <FormFieldLabel label="Email" value={formik.values.contactEmail || 'N/A'} />
          <FormFieldLabel label="Phone Number" value={formik.values.contactPhone || 'N/A'} />
          <FormFieldLabel label="Contact Method" value={selectedContactMethodDescription} />
        </StyledReadOnlyGrid>
      ) : (
        <Row>
          <Col md={6}>
            <FormFieldInput label="Name " required>
              <Form.Control
                name="contactName"
                value={formik.values.contactName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.contactName && !!formik.errors.contactName}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.contactName}</Form.Control.Feedback>
            </FormFieldInput>
          </Col>
          <Col md={6}>
            <FormFieldInput label="Email " required>
              <Form.Control
                type="email"
                name="contactEmail"
                value={formik.values.contactEmail}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.contactEmail && !!formik.errors.contactEmail}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.contactEmail}</Form.Control.Feedback>
            </FormFieldInput>
          </Col>
          <Col md={6}>
            <FormFieldInput label="Phone Number " required>
              <Form.Control
                name="contactPhone"
                value={formik.values.contactPhone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.contactPhone && !!formik.errors.contactPhone}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.contactPhone}</Form.Control.Feedback>
            </FormFieldInput>
          </Col>
          <Col md={6}>
            <FormFieldInput label="Contact Method" required>
              <Form.Control
                as="select"
                name="contactMethodID"
                value={formik.values.contactMethodID}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.contactMethodID && !!formik.errors.contactMethodID}
              >
                <option value={0}>-- Select --</option>
                {metadata?.contactMethods.map((method) => (
                  <option key={method.id} value={method.id}>
                    {method.description}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {String(formik.errors.contactMethodID || '')}
              </Form.Control.Feedback>
            </FormFieldInput>
          </Col>
        </Row>
      )}
      <hr />
    </StyledFormSection>
  )
}
